module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_RaceGamePromo_02.d5ecd571.jpg";